
import SEOHead from '@/components/SEOHead';
import Layout from '@/components/Layout';
import HeroSection from '@/components/property-management/HeroSection';
import StatsSection from '@/components/property-management/StatsSection';
import ServicesSection from '@/components/property-management/ServicesSection';
import ExtraServicesSection from '@/components/property-management/ExtraServicesSection';
import ContactFormSection from '@/components/property-management/ContactFormSection';

const includedServices = [
  "Precios dinámicos y gestión de ingresos",
  "Gestión de canales y distribución multiplataforma",
  "Optimización de anuncios",
  "Gestión de reservas",
  "Asistencia 24/7 en reservas",
  "Análisis de resultados y reportes",
  "Procesamiento automatizado de pagos",
  "Marketing y publicidad",
  "Reportes y estados de cuenta del propietario",
  "Acceso al Portal del Propietario",
  "Seguro",
  "Cumplimiento fiscal",
  "Fotografía profesional",
  "Asignación de un Property Manager",
  "Limpieza y mantenimiento",
  "Servicios para huéspedes y concierge",
];

const extraServices = [
  "Servicio de limpieza profesional",
  "Inspecciones de mantenimiento",
  "Pago mensual de cuentas",
  "Mejoras y consultoría de diseño",
];

const PropertyManagement = () => {
  return (
    <Layout>
      <SEOHead 
        title="Administra tu Propiedad con Estancia Corta"
        description="Deja la gestión de tu propiedad vacacional en manos expertas. Garantizamos mayor tranquilidad y mejores ingresos. Conoce todo lo que incluye nuestro servicio."
      />
      
      <HeroSection />
      <StatsSection />
      <ServicesSection services={includedServices} />
      <ExtraServicesSection services={extraServices} />
      <ContactFormSection />
    </Layout>
  );
};

export default PropertyManagement;
